document.addEventListener('DOMContentLoaded', function () {

  /* --------------------------
     SAFE SELECTORS
  -------------------------- */
  const panel = document.getElementById('mobileFiltersPanel');
  const openBtn = document.getElementById('openMobileFilters');
  const closeBtn = document.getElementById('closeMobileFilters');
  const applyBtn = document.getElementById('applyMobileFilters');
  const resultCount = document.getElementById('resultCount');
  const activeFilterBadge = document.getElementById('activeFilterCount');
  const footer = document.querySelector('footer');

  const productGrid = document.querySelector('.mobile-product-grid');
  const products = productGrid ? Array.from(productGrid.querySelectorAll('.grid-box')) : [];

  const bundleMobile = document.getElementById('bundleToggleMobile');
  const autoShipMobile = document.getElementById('autoShipToggle');
  const outOfStockMobile = document.getElementById('outofstockMobile');
  const dynamicTitle = document.getElementById('dynamicCollectionTitle');
  const dynamicTitleMbl = document.getElementById('dynamicCollectionTitleMbl');

function updateCollectionHeader(desktopTitle, mobileTitle) {
  if (dynamicTitle) dynamicTitle.textContent = desktopTitle || "All Products";
  if (dynamicTitleMbl) dynamicTitleMbl.textContent = mobileTitle || desktopTitle || "All Products";
}

  document.querySelectorAll('.accordion-content').forEach((content) => {
  content.style.height = '0';
  content.style.opacity = '0';
  content.style.paddingTop = '0';

  const btn = content.previousElementSibling;

  if (btn) {
    btn.classList.remove('active');
  }
});

  document.querySelectorAll('.accordion-toggle').forEach((btn) => {
    btn.addEventListener('click', function () {
      const content = this.nextElementSibling;
      if (!content) return;

      if (content.classList.contains('open')) {
        content.style.height = content.scrollHeight + 'px';
        requestAnimationFrame(() => {
          content.style.height = '0';
          content.style.opacity = '0';
          content.style.paddingTop = '0';
        });

        content.addEventListener('transitionend', () => {
          content.classList.remove('open');
          content.style.height = '';
        }, { once: true });

        this.classList.remove('active');

      } else {
        content.classList.add('open');
        this.classList.add('active');

        const targetHeight = content.scrollHeight + 10;
        content.style.height = targetHeight + 'px';

        requestAnimationFrame(() => {
          content.style.opacity = '1';
          content.style.paddingTop = '10px';
        });
      }
    });
  });

  /* --------------------------
     Scroll Function
  -------------------------- */
function scrollToProducts() {
  const header = document.querySelector('.collection-page-header');
  const grid = document.querySelector('.product-grid, .mobile-product-grid');

  const target = header || grid;
  if (!target) return;

  const offset = 100;

  const top =
    target.getBoundingClientRect().top +
    window.pageYOffset -
    offset;

  window.scrollTo({
    top,
    behavior: 'smooth'
  });
}

  /* --------------------------
     CLEAR FILTERS
  -------------------------- */
  const clearBtn = document.getElementById('clearMobileFilters');

  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      document.querySelectorAll('.filter-category, .filter-tag').forEach((cb) => cb.checked = false);
      const defaultSort = document.querySelector("input[name='sort'][value='relevance']");
      if (defaultSort) defaultSort.checked = true;

      filterAndSort(false);
    });
  }

  /* --------------------------
     OPEN / CLOSE PANEL
  -------------------------- */
  if (openBtn && panel && footer) {
    openBtn.addEventListener('click', () => {
      panel.classList.remove('hidden');
      footer.classList.remove('relative');
    });
  }

  if (closeBtn && panel && footer) {
    closeBtn.addEventListener('click', () => {
      panel.classList.add('hidden');
      footer.classList.add('relative');
    });
  }

  /* --------------------------
     FILTER + SORT FUNCTION
  -------------------------- */
  function filterAndSort(updateOnlyCount = false) {

    if (!products.length) return;

    const selectedCategory = document.querySelector('.filter-category:checked')?.value || '';
    updateCollectionHeader(document.querySelector(`.filter-category[value="${selectedCategory}"] + span`)?.textContent || "All Products");
    const selectedTag = document.querySelector('.filter-tag:checked')?.value || '';
    const sortVal = document.querySelector("input[name='sort']:checked")?.value || 'relevance';

    products.forEach((prod) => {
      const productCategories = prod.dataset.collection ? prod.dataset.collection.split(',') : [];
      const productTags = prod.dataset.tags ? prod.dataset.tags.split(',') : [];
      const isSubscription = prod.dataset.subscriptionId && prod.dataset.subscriptionId !== "";
      const inStock = prod.dataset.stock === "true";

      if (autoShipMobile?.checked && !isSubscription) {
        prod.style.display = 'none';
        console.log("Mobile auto ship")
        return;
      }

      if (outOfStockMobile && !outOfStockMobile.checked && !inStock) {
        prod.style.display = 'none';
        console.log("Sold out....")
        return;
      }

      if (bundleMobile?.checked) {
        prod.style.display = productCategories.includes("bundles") ? '' : 'none';
        return;
      }

      const categoryMatch = !selectedCategory || productCategories.includes(selectedCategory);
      const tagMatch = !selectedTag ||productTags.includes(selectedTag);

      prod.style.display = categoryMatch && tagMatch ? '' : 'none';
    });

    if (!updateOnlyCount && productGrid) {
      let visibleProducts = products.filter(p => p.style.display !== 'none');

      visibleProducts.sort((a, b) => {
        const priceA = parseFloat(a.dataset.price);
        const priceB = parseFloat(b.dataset.price);
        if (sortVal === 'price-asc') return priceA - priceB;
        if (sortVal === 'price-desc') return priceB - priceA;
        return 0;
      });

      visibleProducts.forEach(p => productGrid.appendChild(p));
    }

    const totalFilters = (selectedCategory ? 1 : 0) + (selectedTag ? 1 : 0) + (sortVal !== 'relevance' ? 1 : 0);

    if (!bundleMobile?.checked && totalFilters > 0) {
      if (activeFilterBadge) {
        activeFilterBadge.textContent = totalFilters;
        activeFilterBadge.classList.remove('hidden');
      }
    } else {
      if (activeFilterBadge) {
        activeFilterBadge.classList.add('hidden');
      }
    }

    if (resultCount) {
      resultCount.textContent = products.filter(p => p.style.display !== 'none').length;
    }
  }

  /* --------------------------
     EVENTS
  -------------------------- */
document.querySelectorAll(".filter-category, .filter-tag, input[name='sort']").forEach((el) => {

  el.addEventListener('change', () => {

    filterAndSort(false);
    scrollToProducts();
    // CLOSE MOBILE FILTER PANEL
    if (window.innerWidth <= 768 && panel) {
      panel.classList.add('hidden');

      if (footer) {
        footer.classList.add('relative');
      }
    }

  });

});

if (bundleMobile) {
  bundleMobile.addEventListener('change', () => {

    filterAndSort(false);

    if (window.innerWidth <= 768 && panel) {
      panel.classList.add('hidden');

      if (footer) {
        footer.classList.add('relative');
      }
    }

  });
}

if (autoShipMobile) {
  autoShipMobile.addEventListener('change', () => {

    filterAndSort(false);

    if (window.innerWidth <= 768 && panel) {
      panel.classList.add('hidden');

      if (footer) {
        footer.classList.add('relative');
      }
    }

  });
}

if (outOfStockMobile) {
  outOfStockMobile.addEventListener('change', () => {

    filterAndSort(false);

    if (window.innerWidth <= 768 && panel) {
      panel.classList.add('hidden');

      if (footer) {
        footer.classList.add('relative');
      }
    }

  });
}
  /* --------------------------
     INIT
  -------------------------- */
  filterAndSort(false);

  /* --------------------------
     AUTO-SHIP LOGIC (SAFE)
  -------------------------- */
 function initAutoShipToggle(toggleId) {
     const toggle = document.getElementById(toggleId);
    if (!toggle) return;
    const products = document.querySelectorAll('.grid-box');

    function updateProductSubscription(box, enable) {
       const badgeContainer = box.querySelector('.item-flag');
       const badge = box.querySelector('.discount-badge');
      const selectBox = box.querySelector('.subscription-select');
       const select = box.querySelector('.subscription-plan-select');
       const sellingPlanInput = box.querySelector('input[name="selling_plan"]');
      const otherBadges = box.querySelectorAll('.other-badge');

      const sellingPlanId = enable ? box.dataset.subscriptionId : "";

       const priceWrapper = box.querySelector('.button-label-product-price');
       const normalPrice = priceWrapper?.querySelector('.normal-price');
     const subPrice = priceWrapper?.querySelector('.subscription-price');
       const comparePrice = box.querySelector('[data-price-compare]');

       const variantButtons = box.querySelectorAll('.variant-option-inline');

       variantButtons.forEach(btn => {
        const variantPrice = btn.querySelector('.variant-price');
         const variantComparePrice = btn.querySelector('.variant-compare-price');
        const variantSubPrice = btn.querySelector('.variant-subscription-price');
         const variantOriginalSub = btn.querySelector('.variant-original-subscription');

         if (enable) {
          variantPrice?.classList.add('hidden');
           variantComparePrice?.classList.add('hidden');
           variantSubPrice?.classList.remove('hidden');
           variantOriginalSub?.classList.remove('hidden');
        } else {
          variantPrice?.classList.remove('hidden');
          variantComparePrice?.classList.remove('hidden');
          variantSubPrice?.classList.add('hidden');
           variantOriginalSub?.classList.add('hidden');
         }
       });

       if (enable) {
       normalPrice?.classList.add('hidden');
         subPrice?.classList.remove('hidden');
        comparePrice?.classList.add('hidden');
       } else {
        normalPrice?.classList.remove('hidden');
         subPrice?.classList.add('hidden');
         comparePrice?.classList.remove('hidden');
      }

       if (selectBox) selectBox.classList.toggle('hidden', !enable);
       if (sellingPlanInput) sellingPlanInput.value = sellingPlanId;
       if (select) select.value = sellingPlanId || "";

       if (!enable) {
         badgeContainer?.classList.add('hidden');
          otherBadges.forEach(el => el.classList.remove('hidden'));
         return;
       }
       otherBadges.forEach(el => el.classList.add('hidden'));

       const saveAmount = parseFloat(box.dataset.savePrice) / 100;
       const currency = Shopify.currency?.active || Shopify.currency?.default || 'USD';

       const formattedSave = new Intl.NumberFormat(undefined, {
         style: 'currency',
         currency: currency,
         minimumFractionDigits: 0,
         maximumFractionDigits: 0
       }).format(saveAmount);

       if (badge) {
         badge.innerHTML = `Save ${formattedSave}`;
         badgeContainer?.classList.remove('hidden');
       }
     }

     if (toggle.checked) products.forEach(box => updateProductSubscription(box, true));

     toggle.addEventListener('change', function () {
       const enable = this.checked;
       products.forEach(box => updateProductSubscription(box, enable));
     });

     document.addEventListener('change', function(e){
       if(!e.target.classList.contains('subscription-plan-select')) return;
       const box = e.target.closest('.grid-box');
       const planId = e.target.value;
       const sellingPlanInput = box.querySelector('input[name="selling_plan"]');
       box.dataset.subscriptionId = planId;
       if (sellingPlanInput) sellingPlanInput.value = planId;
       const toggle = document.getElementById('autoShipToggle') || document.getElementById('autoShipToggleDesktop');
       const enable = toggle?.checked;
       if (enable) updateProductSubscription(box, true);
     });
   }

  initAutoShipToggle('autoShipToggle');
  initAutoShipToggle('autoShipToggleDesktop');

  /* --------------------------
     DESKTOP FILTERS (SAFE)
  -------------------------- */
  const desktopGrid = document.querySelector('.product-grid');
  if (!desktopGrid) return;

  const desktopProducts = Array.from(desktopGrid.querySelectorAll('.grid-box'));
  const autoShipDesktop = document.getElementById('autoShipToggleDesktop');
  const bundleDesktop = document.getElementById('bundleToggle');
  const outOfStockDesktop = document.getElementById('outofstock');

  function filterDesktopProducts() {

      const selectedCategory = document.querySelector('.desktop-filters .filter-category:checked')?.value || '';
      const selectedTag = document.querySelector('.desktop-filters .filter-tag:checked')?.value || '';
      updateCollectionHeader(document.querySelector(`.filter-category[value="${selectedCategory}"] + span`)?.textContent || "All Products");

    desktopProducts.forEach(prod => {
      const productCategories = prod.dataset.collection?.split(',') || [];
      const productTags = prod.dataset.tags?.split(',') || [];
      const inStock = prod.dataset.stock === "true";
      const isSubscription = prod.dataset.subscriptionId && prod.dataset.subscriptionId !== "";

      // AUTO-SHIP FILTER
      if (autoShipDesktop?.checked && !isSubscription) {
        prod.style.display = 'none';
        return;
      }

      // OUT OF STOCK TOGGLE LOGIC
      if (outOfStockDesktop && !outOfStockDesktop.checked && !inStock) {
        prod.style.display = 'none';
        return;
      }

      if (bundleDesktop?.checked) {
        prod.style.display = productCategories.includes("bundles") ? '' : 'none';
        return;
      }

      const categoryMatch = !selectedCategory || productCategories.includes(selectedCategory);
      const tagMatch = !selectedTag ||productTags.includes(selectedTag);

      prod.style.display = categoryMatch && tagMatch ? '' : 'none';
    });
  }

  document.querySelectorAll('.desktop-filters input').forEach(el => {
   el.addEventListener('change', () => {
    filterDesktopProducts();
    scrollToProducts();
  });
  });

});

/* --------------------------
   SUBSCRIPTION TEXT FIX
-------------------------- */
document.addEventListener("DOMContentLoaded", function () {

  const options = document.querySelectorAll('.subscription-plan-select option');

  options.forEach(option => {
    option.dataset.originalText = option.textContent;
  });

  function updateOptions() {
    const isMobile = window.innerWidth <= 768;

    options.forEach(option => {
      option.textContent = isMobile
        ? option.dataset.originalText.replace(/\s*\(.*?\)/g, '').replace(/every\s*/i, '')
        : option.dataset.originalText;
    });
  }

  updateOptions();

  let resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(updateOptions, 150);
  });

});

